import styled from "styled-components";

export const SlctBox = styled.div`
    width: ${p => p.width ? p.width : '100%'};
    position: relative;
`;
export const SlctBoxWrap = styled.div`
    width: 100%;
    height: 40px;
    background-color: #fff;
    border-radius: 4px;
    border: 1px #9B9B9B solid;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 15px;
    cursor: pointer;
    ${p => p.isError && `
        border-color: #EB2026;
    `}
    /* ${p => p.active && `
        border-color: #008CFF;
    `} */
    label{
        font-size: 14px;
        color: #4A4A4A;
        font-weight: 400;
    }
    &::after{
        display: inline-flex;
        border: solid #999999;
        border-width: 0 1px 1px 0;
        padding: 3px;
        content: "";
        transform: rotate(45deg);
        margin-left: 10px;
        flex-shrink: 0;
        margin-top: -3px;
    }
`;
export const SlctBoxContent = styled.div`
    width: 100%;
    background-color: #fff;
    box-shadow: 0 0 6px rgba(0,0,0,0.2);
    position: absolute;
    left: 0;
    top: 40px;
    border-radius: 4px;
    z-index: 2;
    max-height: 200px;
    overflow-y: auto;
`;
export const OptionList = styled.ul`
    
`;
export const OptionListItem = styled.li`
    cursor: pointer;
    padding: 10px 15px;
    :hover{
        background-color: #efefef;
    }
`;
export const ErrMsg = styled.p`
    font-size: 11px;
    font-weight: 700;
    color: #EB2026;
    margin-top: 4px;
`;
